import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Layouts
import { CommonLayoutComponent } from "./common/common-layout/common-layout.component";
import { AdminCommonLayoutComponent } from "./common/admin-common-layout/admin-common-layout.component";

import { AuthenticationLayoutComponent } from "./common/authentication-layout/authentication-layout.component";
import { EventLayoutComponent } from "./common/event-layout/event-layout.component";

import { DashGuard } from "./services/admincheck.service";

import { AuthGuard } from "./services/authentication.service";

export const AppRoutes: Routes = [
  {
    path: "",
    canActivate: [DashGuard],
    redirectTo: "",
    pathMatch: "full",
  },
  {
    path: "",
    component: CommonLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: "./dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "programs",
        loadChildren: "./programs/program.module#ProgramsModule",
      },
      {
        path: "speakers",
        loadChildren: "./speakers/speaker.module#SpeakersModule",
      },
      {
        path: "participants",
        loadChildren: "./participants/participant.module#ParticipantsModule",
      },
      {
        path: "webview",
        loadChildren: "./webview/webview.module#WebViewModule",
      },
      {
        path: "whitelabel",
        loadChildren: "./whitelabel/whitelabel.module#WhiteLabelModule",
      },
      {
        path: "news",
        loadChildren: "./news/news.module#NewsModule",
      },
      {
        path: "contacts",
        loadChildren: "./contacts/contacts.module#ContactsModule",
      },
      {
        path: "sponsers",
        loadChildren: "./sponsers/sponsers.module#SponsersModule",
      },
      {
        path: "extras",
        loadChildren:
          "./user-management/user-management.module#UserManagementModule",
      },
      {
        path: "publish",
        loadChildren: "./pub2/pub2.module#Pub2Module",
      },
      {
        path: "feedback",
        loadChildren: "./feedback/feedback.module#FeedbackModule",
      },
      {
        path: "materials",
        loadChildren: "./materials/materials.module#MaterialsModule",
      },
      {
        path: "social",
        loadChildren: "./social-wall/social-wall.module#SocialWallModule",
      },
      {
        path: "twitter",
        loadChildren: "./twitter/twitter.module#TwitterModule",
      },
      {
        path: "upgrade",
        loadChildren: "./upgrade/upgrade.module#UpgradeModule",
      },
      {
        path: "allevents",
        loadChildren: "./allevents/allevents.module#AllEventsModule",
      },
      {
        path: "eventdetails",
        loadChildren: "./event-details/event-details.module#EventDetailsModule",
      },
    ],
  },
  {
    path: "",
    component: AuthenticationLayoutComponent,
    children: [
      {
        path: "authentication",
        loadChildren:
          "./user-authentication/user-authentication.modules#UserAuthenticationModule",
      },
    ],
  },
  {
    path: "",
    component: EventLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "events",
        loadChildren: "./events/events.module#EventsModule",
      },
      {
        path: "eventsAdd",
        loadChildren: "./events2/events.module#Events2Module",
      },
    ],
  },
  {
    path: "",
    component: AdminCommonLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "organisations",
        loadChildren: "./admin-org/admin-org.module#AdminOrgModule",
      },
      {
        path: "adminevents",
        loadChildren: "./admin-events/admin-events.module#AdminEventsModule",
      },
    ],
  },
];



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/app.routing.ts